import { lazy } from "react";

// Helper function to handle lazy loading with page reload on failure
export const lazyWithReload = (
  importFn: () => Promise<{ default: React.ComponentType }>
) => {
  return lazy(() =>
    importFn().catch((error) => {
      console.error("Lazy loading failed, reloading page:", error);
      window.location.reload();
      // Return a never-resolving promise to prevent further execution
      return new Promise(() => {});
    })
  );
};
